(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-complete-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-shop-look')) {
    class SpShopLook extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.sp-look__item')];
        this.hotspots = [...this.querySelectorAll('.sp-look__hotspot')];
        this.totalEl = this.querySelector('[data-total]');
        this.statusEl = this.querySelector('[data-status]');
        this.moneyFormat = this.dataset.moneyFormat || '';

        this.items.forEach((item) => {
          item.addEventListener('pointerenter', () => this.setActive(item.dataset.index));
          item.addEventListener('pointerleave', () => this.setActive(null));
          item.addEventListener('focusin', () => this.setActive(item.dataset.index));
          item.addEventListener('focusout', () => this.setActive(null));
          item.querySelector('[data-variant-select]')?.addEventListener('change', (e) => this.onVariantChange(item, e.target));
          item.querySelector('[data-add]')?.addEventListener('click', (e) => this.addItem(item, e.currentTarget));
        });

        this.hotspots.forEach((spot) => {
          spot.addEventListener('pointerenter', () => this.setActive(spot.dataset.index));
          spot.addEventListener('pointerleave', () => this.setActive(null));
          spot.addEventListener('click', () => {
            const item = this.items.find((i) => i.dataset.index === spot.dataset.index);
            if (!item) return;
            this.setActive(spot.dataset.index);
            if (window.matchMedia('(max-width: 989px)').matches) {
              item.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
            item.classList.remove('is-flash');
            void item.offsetWidth;
            item.classList.add('is-flash');
          });
        });

        this.querySelector('[data-add-all]')?.addEventListener('click', (e) => this.addAll(e.currentTarget));
      }

      setActive(index) {
        this.items.forEach((i) => i.classList.toggle('is-active', i.dataset.index === index));
        this.hotspots.forEach((h) => h.classList.toggle('is-active', h.dataset.index === index));
      }

      formatMoney(cents) {
        const format = this.moneyFormat;
        const value = Number(cents) / 100;
        const withDelimiters = (number, decimals, thousands = ',', decimal = '.') => {
          const [whole, fraction] = number.toFixed(decimals).split('.');
          return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
        };
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!match) return value.toFixed(2);
        const map = {
          amount: () => withDelimiters(value, 2),
          amount_no_decimals: () => withDelimiters(value, 0),
          amount_with_comma_separator: () => withDelimiters(value, 2, '.', ','),
          amount_no_decimals_with_comma_separator: () => withDelimiters(value, 0, '.', ','),
          amount_with_apostrophe_separator: () => withDelimiters(value, 2, "'", '.'),
        };
        return format.replace(match[0], (map[match[1]] || map.amount)());
      }

      onVariantChange(item, select) {
        const option = select.selectedOptions[0];
        const button = item.querySelector('[data-add]');
        if (button) button.dataset.variantId = option.value;

        const price = item.querySelector('[data-price]');
        const compare = item.querySelector('[data-compare]');
        if (price) price.textContent = this.formatMoney(option.dataset.price);
        if (compare) {
          const onSale = Number(option.dataset.compare) > Number(option.dataset.price);
          compare.hidden = !onSale;
          if (onSale) compare.textContent = this.formatMoney(option.dataset.compare);
        }
        this.updateTotal();
      }

      updateTotal() {
        if (!this.totalEl) return;
        let total = 0;
        this.items.forEach((item) => {
          const button = item.querySelector('[data-add]');
          if (!button) return;
          const select = item.querySelector('[data-variant-select]');
          const cents = select ? select.selectedOptions[0].dataset.price : null;
          if (cents) total += Number(cents);
          else total += Number(item.querySelector('[data-price]')?.dataset.cents || 0);
        });
        if (total > 0) this.totalEl.textContent = this.formatMoney(total);
      }

      addItem(item, button) {
        this.addLines([{ id: Number(button.dataset.variantId), quantity: 1 }], button);
      }

      addAll(button) {
        const lines = this.items
          .map((item) => item.querySelector('[data-add]'))
          .filter(Boolean)
          .map((btn) => ({ id: Number(btn.dataset.variantId), quantity: 1 }));
        if (lines.length) this.addLines(lines, button);
      }

      setStatus(message, isError = false) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        this.statusEl.classList.toggle('is-error', isError);
        clearTimeout(this.statusTimer);
        this.statusTimer = setTimeout(() => (this.statusEl.textContent = ''), 4000);
      }

      async addLines(lines, trigger) {
        if (trigger.getAttribute('aria-busy') === 'true') return;
        trigger.setAttribute('aria-busy', 'true');

        const routes = window.Theme?.routes || {};
        const addUrl = routes.cart_add_url || '/cart/add.js';
        const cartUrl = routes.cart_url || '/cart';
        const sectionIds = [...document.querySelectorAll('cart-items-component')]
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        const quantity = lines.reduce((sum, line) => sum + line.quantity, 0);

        // Horizon's cart drawer, cart count and cart page listen for this event
        let events = null;
        try {
          events = await import('@shopify/events');
        } catch (error) {
          events = null;
        }
        const CartEvent = events?.CartLinesUpdateEvent;
        const deferred = CartEvent?.createPromise ? CartEvent.createPromise() : null;

        if (deferred) {
          this.dispatchEvent(
            new CartEvent({
              action: 'add',
              context: 'product',
              lines: lines.map((line) => ({ merchandiseId: String(line.id), quantity: line.quantity })),
              promise: deferred.promise,
            })
          );
        }

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lines, sections: sectionIds.join(',') }),
          }).then((res) => res.json());

          const cart = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((res) =>
            res.json()
          );

          if (response.status) {
            deferred?.resolve({
              cart: CartEvent.createCartFromAjaxResponse(cart),
              detail: { didError: true, items: cart.items, source: 'product-form-component', sourceId: this.id, itemCount: 0 },
            });
            this.setStatus(response.description || response.message || 'Could not add to cart', true);
            return;
          }

          if (deferred) {
            deferred.resolve({
              cart: CartEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'product-form-component',
                sourceId: this.id,
                itemCount: quantity,
                sections: response.sections,
                didError: false,
              },
            });
          } else {
            window.location.href = cartUrl;
            return;
          }
          // Open Horizon's cart drawer once its contents have refreshed
          const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
          if (cartDrawer && !cartDrawer.isOpen) {
            requestAnimationFrame(() => cartDrawer.open?.());
          }
          trigger.classList.add('is-added');
          setTimeout(() => trigger.classList.remove('is-added'), 2200);
          this.setStatus(quantity > 1 ? `${quantity} pieces added to cart` : 'Added to cart');
        } catch (error) {
          deferred?.reject(error);
          this.setStatus('Something went wrong. Please try again.', true);
        } finally {
          trigger.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('sp-shop-look', SpShopLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-featured-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-edit-tabs')) {
    class SpEditTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('.sp-edit__panel')];
        this.tablist = this.querySelector('[role="tablist"]');
        this.indicator = this.querySelector('.sp-edit__indicator');
        this.cta = this.querySelector('[data-sp-cta]');
        this.ctaLabel = this.querySelector('[data-sp-cta-label]');
        if (this.tabs.length < 2) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKey(event, index));
        });

        this.resizeObserver = new ResizeObserver(() => this.moveIndicator(false));
        this.resizeObserver.observe(this.tablist);
        document.fonts?.ready.then(() => this.moveIndicator(false));
        this.moveIndicator(false);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      onKey(event, index) {
        const last = this.tabs.length - 1;
        const keys = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        };
        if (!(event.key in keys)) return;
        event.preventDefault();
        this.select(keys[event.key]);
        this.tabs[keys[event.key]].focus();
      }

      select(index) {
        const tab = this.tabs[index];
        if (!tab || tab.getAttribute('aria-selected') === 'true') return;

        this.tabs.forEach((t, i) => {
          const active = i === index;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
        });

        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.hidden = !active;
          panel.classList.toggle('is-entering', active);
        });

        clearTimeout(this.enterTimer);
        this.enterTimer = setTimeout(() => {
          this.panels[index]?.classList.remove('is-entering');
        }, 900);

        if (this.cta && tab.dataset.url) this.cta.href = tab.dataset.url;
        if (this.ctaLabel && tab.dataset.cta) this.ctaLabel.textContent = tab.dataset.cta;

        tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        this.moveIndicator(true);

        // Let Horizon carousels re-measure now that the panel is visible
        window.dispatchEvent(new Event('resize'));
      }

      moveIndicator(animate) {
        const active = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true');
        if (!active || !this.indicator) return;
        this.indicator.classList.toggle('is-animated', animate);
        this.indicator.style.width = `${active.offsetWidth}px`;
        this.indicator.style.transform = `translateX(${active.offsetLeft}px)`;
      }
    }

    customElements.define('sp-edit-tabs', SpEditTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-premium-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-sevenpar-collection-v3')) {
    class SpSevenparCollectionV3 extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        this.root = this.querySelector('[data-sp-collection]') || this;
        this.grid = this.querySelector('[data-product-grid]');
        this.form = this.querySelector('[data-filter-form]');
        this.overlay = this.querySelector('[data-filter-overlay]');
        this.sidebar = this.querySelector('[data-filter-panel]');
        this.dialog = this.querySelector('[data-quick-dialog]');
        this.moneyFormat = this.root?.dataset.moneyFormat || String.fromCharCode(36, 123, 123) + 'amount' + String.fromCharCode(125, 125);
        this.shopRoot = window.Shopify?.routes?.root || '/';
        this.prevBodyOverflow = '';
        this.form?.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!this.validatePriceInputs()) return;
          const url = new URL(this.form.action, window.location.origin);
          for (const [name, value] of new FormData(this.form)) {
            if (String(value).trim()) url.searchParams.append(name, value);
          }
          this.loadUrl(url.toString());
        });
        this.querySelectorAll('.sp-collection__filter-pill, .sp-collection__clear, .sp-collection__clear-inline, [data-price-reset]').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.loadUrl(link.href);
          });
        });
        this.onPopState = () => window.location.reload();
        window.addEventListener('popstate', this.onPopState);

        this.querySelectorAll('[data-auto-filter]').forEach((element) => {
          element.addEventListener('change', () => this.form?.requestSubmit());
        });
        this.querySelectorAll('[data-price-input]').forEach((element) => {
          element.addEventListener('input', () => {
            const error = this.querySelector('[data-price-error]');
            if (error) {
              error.hidden = true;
              error.textContent = '';
            }
            this.querySelectorAll('[data-price-input]').forEach((input) => input.removeAttribute('aria-invalid'));
          });
        });

        const sort = this.querySelector('[data-sort-select]');
        sort?.addEventListener('change', () => {
          if (this.form) {
            this.querySelector('[data-sort-hidden]').value = sort.value;
            this.form.requestSubmit();
          } else {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', sort.value);
            url.searchParams.delete('page');
            window.location.assign(url.toString());
          }
        });

        this.querySelectorAll('[data-grid-cols]').forEach((button) => {
          button.addEventListener('click', () => {
            if (!this.grid) return;
            this.grid.dataset.cols = button.dataset.gridCols;
            this.querySelectorAll('[data-grid-cols]').forEach((other) => {
              const active = other === button;
              other.classList.toggle('is-current', active);
              other.setAttribute('aria-pressed', String(active));
            });
          });
        });

        this.querySelector('[data-open-filters]')?.addEventListener('click', () => this.openFilters());
        this.querySelectorAll('[data-close-filters]').forEach((button) => button.addEventListener('click', () => this.closeFilters()));
        this.overlay?.addEventListener('click', () => this.closeFilters());
        this.querySelector('[data-back-to-top]')?.addEventListener('click', (event) => this.scrollToPageTop(event));
        this.querySelectorAll('[data-quick-view]').forEach((button) => {
          button.addEventListener('click', () => this.openQuick(button));
        });
        this.dialog?.addEventListener('close', () => this.unlockPage());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-close-quick]')) {
            this.closeQuick();
            return;
          }
          const choice = event.target.closest('[data-quick-option]');
          if (choice && this.dialog.contains(choice)) {
            this.selectQuickOption(choice);
            return;
          }
          if (event.target.closest('[data-quick-add]')) this.addToCart();
        });
        this.onKeyDown = (event) => {
          if (event.key === 'Escape') this.closeFilters();
        };
        document.addEventListener('keydown', this.onKeyDown);
      }

      // Preserve Shopify's filter.min_value/max_value parameter names and native range limits.
      // Validate localized user input before submitting through the collection Ajax form.
      validatePriceInputs() {
        const panel = this.querySelector('[data-native-price-filter]');
        if (!panel) return true;
        const lower = panel.querySelector('[data-price-side="min"]');
        const upper = panel.querySelector('[data-price-side="max"]');
        const error = panel.querySelector('[data-price-error]');
        const highest = Number(panel.dataset.highest);
        const parsePrice = (raw) => {
          let value = String(raw || '').trim().replace(/\s/g, '');
          if (!value) return { amount: null, normalized: '' };
          const comma = value.lastIndexOf(',');
          const dot = value.lastIndexOf('.');
          if (comma !== -1 && dot !== -1) {
            value = comma > dot ? value.replace(/\./g, '').replace(',', '.') : value.replace(/,/g, '');
          } else if (comma !== -1) {
            const tail = value.slice(comma + 1);
            value = tail.length === 3 ? value.replace(/,/g, '') : value.replace(',', '.');
          }
          if (!/^\d+(?:\.\d{1,2})?$/.test(value)) return { amount: NaN, normalized: value };
          return { amount: Number(value), normalized: value };
        };
        const min = parsePrice(lower?.value);
        const max = parsePrice(upper?.value);
        const showError = (message, field) => {
          if (error) {
            error.textContent = message;
            error.hidden = false;
          }
          if (field) {
            field.setAttribute('aria-invalid', 'true');
            field.focus();
          }
          return false;
        };
        if (min.amount !== null && (!Number.isFinite(min.amount) || min.amount < 0)) {
          return showError('Enter a valid minimum price.', lower);
        }
        if (max.amount !== null && (!Number.isFinite(max.amount) || max.amount < 0)) {
          return showError('Enter a valid maximum price.', upper);
        }
        if (min.amount !== null && min.amount > highest) return showError('Minimum price exceeds the available range.', lower);
        if (max.amount !== null && max.amount > highest) return showError('Maximum price exceeds the available range.', upper);
        if (min.amount !== null && max.amount !== null && min.amount > max.amount) {
          return showError('Minimum price must be less than or equal to maximum price.', upper);
        }
        if (lower) lower.value = min.normalized;
        if (upper) upper.value = max.normalized;
        if (error) {
          error.textContent = '';
          error.hidden = true;
        }
        return true;
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('popstate', this.onPopState);
        if (this.sidebar?.classList.contains('is-open')) this.unlockPage();
      }

      // Native anchor remains a working fallback even if the section JS is interrupted.
      // Scroll the actual document scroller, not the section or product grid.
      scrollToPageTop(event) {
        if (event) event.preventDefault();
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        try {
          const scroller = document.scrollingElement || document.documentElement;
          if (typeof scroller.scrollTo === 'function') {
            scroller.scrollTo({ top: 0, left: 0, behavior });
          } else {
            window.scrollTo({ top: 0, left: 0, behavior });
          }
        } catch (_) {
          window.scrollTo(0, 0);
        }
      }
      lockPage() {
        this.prevBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      unlockPage() { document.body.style.overflow = this.prevBodyOverflow; }
      openFilters() {
        if (!this.sidebar) return;
        this.sidebar.classList.add('is-open');
        if (this.overlay) this.overlay.hidden = false;
        this.querySelector('[data-open-filters]')?.setAttribute('aria-expanded', 'true');
        this.lockPage();
        this.querySelector('[data-close-filters]')?.focus();
      }
      closeFilters() {
        if (!this.sidebar?.classList.contains('is-open')) return;
        this.sidebar.classList.remove('is-open');
        if (this.overlay) this.overlay.hidden = true;
        this.querySelector('[data-open-filters]')?.setAttribute('aria-expanded', 'false');
        this.unlockPage();
        this.querySelector('[data-open-filters]')?.focus();
      }
      async loadUrl(nextUrl) {
        this.setAttribute('aria-busy', 'true');
        try {
          const sectionId = this.root?.dataset.sectionId;
          if (!sectionId) throw new Error('Section ID not available');
          const url = new URL(nextUrl, window.location.origin);
          const urlForSection = new URL(url.toString());
          urlForSection.searchParams.set('section_id', sectionId);
          const response = await fetch(urlForSection, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Section update unavailable');
          const markup = await response.text();
          const doc = new DOMParser().parseFromString(markup, 'text/html');
          const replacement = doc.querySelector('sp-sevenpar-collection-v3');
          if (!replacement) throw new Error('Section markup missing');
          replacement.removeAttribute('data-bound');
          window.history.pushState({}, '', url.toString());
          this.replaceWith(replacement);
        } catch (error) {
          window.location.assign(nextUrl);
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
      formatMoney(cents) {
        const amount = Number(cents) / 100;
        const match = this.moneyFormat.match(/\{\{\s*([a-z_]+)\s*\}\}/);
        if (!match) return amount.toFixed(2);
        const type = match[1];
        const decimals = type.includes('no_decimals') ? 0 : 2;
        const separator = type.includes('comma_separator') ? ',' : '.';
        const thousands = type.includes('comma_separator') ? '.' : ',';
        const num = amount.toFixed(decimals).split('.');
        const whole = num[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return this.moneyFormat.replace(match[0], whole + (decimals ? separator + num[1] : ''));
      }
      setMessage(message, error = false) {
        const el = this.querySelector('[data-quick-message]');
        if (!el) return;
        el.textContent = message;
        el.classList.toggle('is-error', error);
      }
      closeQuick() {
        this.quickImageToken = (this.quickImageToken || 0) + 1;
        if (this.dialog?.open) this.dialog.close();
        this.unlockPage();
      }
      // All modal details come from the product's Shopify Liquid template.
      // No Ajax product request, loading message, or JSON parsing of the entire product.
      openQuick(button) {
        if (!this.dialog || this.dialog.open) return;
        const templateId = button.dataset.quickTemplate;
        const template = templateId ? this.querySelector(`[id="${templateId}"]`) : null;
        if (!(template instanceof HTMLTemplateElement)) {
          // Safe, visible product-page fallback instead of an empty/broken popup.
          if (button.dataset.productUrl) window.location.assign(button.dataset.productUrl);
          return;
        }
        const container = this.dialog.querySelector('[data-quick-content]');
        if (!container) return;
        container.replaceChildren(template.content.cloneNode(true));
        this.quickImageToken = (this.quickImageToken || 0) + 1;
        this.variant = null;
        this.syncQuickVariant();
        this.dialog.showModal();
        this.lockPage();
      }
      // Variant rows of the open product: [{ options: [...], available: bool }]
      quickRows(product) {
        return [...product.querySelectorAll('[data-quick-variant]')].map((row) => {
          let options = [];
          try { options = JSON.parse(row.dataset.variantOptions || '[]'); } catch (_) { options = []; }
          return { options, available: row.dataset.variantAvailable === 'true' };
        });
      }
      selectQuickOption(choice) {
        const group = choice.closest('[data-quick-group]');
        const product = this.dialog?.querySelector('[data-quick-product]');
        if (!group || !product) return;
        group.querySelectorAll('[data-quick-option]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === choice));
        });
        // Out of stock options are hidden, so never land on one: move to the closest variant that can be bought
        const groups = [...product.querySelectorAll('[data-quick-group]')];
        const index = groups.indexOf(group);
        const want = groups.map((g) => g.querySelector('[data-quick-option][aria-pressed="true"]')?.dataset.optionValue || null);
        const rows = this.quickRows(product);
        const exact = rows.find((r) => r.options.length === want.length && r.options.every((o, i) => o === want[i]));
        if (!exact || !exact.available) {
          const best = rows
            .filter((r) => r.available && r.options[index] === want[index])
            .map((r) => ({ r, s: r.options.reduce((a, o, i) => a + (i !== index && o === want[i] ? 1 : 0), 0) }))
            .sort((a, b) => b.s - a.s)[0];
          if (best) {
            groups.forEach((g, i) => {
              g.querySelectorAll('[data-quick-option]').forEach((item) => {
                item.setAttribute('aria-pressed', String(item.dataset.optionValue === best.r.options[i]));
              });
            });
          }
        }
        this.syncQuickVariant();
      }
      // Hide option values that are out of stock or don't exist for the current choice
      refreshQuickOptions(product, selections) {
        const rows = this.quickRows(product);
        [...product.querySelectorAll('[data-quick-group]')].forEach((group, index) => {
          group.querySelectorAll('[data-quick-option]').forEach((pill) => {
            const value = pill.dataset.optionValue;
            const ok = index === 0
              ? rows.some((r) => r.available && r.options[0] === value)
              : rows.some((r) => r.available && r.options[index] === value && r.options.every((o, i) => i === index || o === selections[i]));
            pill.hidden = !ok && pill.getAttribute('aria-pressed') !== 'true';
          });
        });
      }
      syncQuickVariant() {
        const product = this.dialog?.querySelector('[data-quick-product]');
        if (!product) return;
        const selections = [...product.querySelectorAll('[data-quick-group]')].map((group) =>
          group.querySelector('[data-quick-option][aria-pressed="true"]')?.dataset.optionValue || null
        );
        const rows = [...product.querySelectorAll('[data-quick-variant]')];
        const selectedRow = rows.find((row) => {
          if (selections.length === 0) return row.dataset.variantId === product.dataset.defaultVariantId;
          try {
            const options = JSON.parse(row.dataset.variantOptions || '[]');
            return options.length === selections.length && options.every((value, i) => value === selections[i]);
          } catch (_) { return false; }
        });
        this.refreshQuickOptions(product, selections);
        const button = product.querySelector('[data-quick-add]');
        const price = product.querySelector('[data-quick-price]');
        if (!button) return;
        if (!selectedRow) {
          this.variant = null;
          button.disabled = true;
          button.textContent = 'Unavailable combination';
          this.setMessage('Choose another combination.');
          return;
        }
        this.variant = { id: Number(selectedRow.dataset.variantId), available: selectedRow.dataset.variantAvailable === 'true' };
        if (price) price.textContent = selectedRow.dataset.variantPrice || price.textContent;
        button.dataset.variantId = selectedRow.dataset.variantId;
        button.disabled = !this.variant.available;
        button.textContent = this.variant.available ? 'Add to bag' : 'Sold out';
        if (selectedRow.dataset.variantImage) this.setQuickVariantImage(selectedRow.dataset.variantImage, selectedRow.dataset.variantSrcset);
        this.setMessage('');
      }
      // Swap the photo for the chosen colour. The modal image has a srcset, so src AND srcset
      // must change together, otherwise the browser keeps showing the old photo.
      // The new photo is preloaded first so the modal never shows an empty frame.
      setQuickVariantImage(src, srcset) {
        if (!src) return;
        const displayed = this.dialog?.querySelector('.sp-collection__modal-image');
        if (!(displayed instanceof HTMLImageElement)) return;
        const absoluteSrc = new URL(src, window.location.href).href;
        if (displayed.dataset.variantSrc === absoluteSrc) return;
        const token = ++this.quickImageToken;
        const preloader = new Image();
        if (srcset) {
          preloader.sizes = displayed.getAttribute('sizes') || '(min-width: 750px) 400px, 94vw';
          preloader.srcset = srcset;
        }
        const applyImage = () => {
          if (token !== this.quickImageToken) return;
          displayed.dataset.variantSrc = absoluteSrc;
          if (srcset) displayed.srcset = srcset;
          else displayed.removeAttribute('srcset');
          displayed.src = absoluteSrc;
        };
        preloader.onload = applyImage;
        preloader.onerror = applyImage;
        preloader.src = absoluteSrc;
        if (preloader.complete) applyImage();
      }
      async addToCart() {
        if (!this.variant?.available) return;
        const button = this.querySelector('[data-quick-add]');
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        this.setMessage('Adding to your bag...');
        const lines = [{ id: Number(this.variant.id), quantity: 1 }];
        const sectionIds = [...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean).slice(0,5);
        let EventType = null, deferred = null;
        try {
          const events = await import('@shopify/events');
          EventType = events?.CartLinesUpdateEvent;
          deferred = EventType?.createPromise ? EventType.createPromise() : null;
          if (deferred) {
            this.dispatchEvent(new EventType({
              action: 'add', context: 'product',
              lines: [{ merchandiseId: String(this.variant.id), quantity: 1 }],
              promise: deferred.promise,
            }));
          }
        } catch (_) { deferred = null; }
        try {
          const response = await fetch(`${this.shopRoot}cart/add.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lines, ...(sectionIds.length ? { sections: sectionIds.join(',') } : {}) }),
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add the product');
          if (deferred && EventType?.createCartFromAjaxResponse) {
            const cartResponse = await fetch(`${this.shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            deferred.resolve({
              cart: EventType.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'product-form-component', sourceId: this.id || 'sp-collection-quick', itemCount: 1, sections: result.sections, didError: false },
            });
          }
          this.closeQuick();
          const drawer = document.querySelector('theme-drawer#cart-drawer');
          if (drawer && deferred) {
            requestAnimationFrame(() => drawer.open?.());
          } else {
            window.location.assign(`${this.shopRoot}cart`);
          }
        } catch (error) {
          deferred?.reject(error);
          this.setMessage(error.message || 'Could not add the item. Please try again.', true);
          button.disabled = !this.variant?.available;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('sp-sevenpar-collection-v3', SpSevenparCollectionV3);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-shop-look')) {
    class SpShopLook extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.sp-look__item')];
        this.hotspots = [...this.querySelectorAll('.sp-look__hotspot')];
        this.totalEl = this.querySelector('[data-total]');
        this.statusEl = this.querySelector('[data-status]');
        this.moneyFormat = this.dataset.moneyFormat || '';

        this.items.forEach((item) => {
          item.addEventListener('pointerenter', () => this.setActive(item.dataset.index));
          item.addEventListener('pointerleave', () => this.setActive(null));
          item.addEventListener('focusin', () => this.setActive(item.dataset.index));
          item.addEventListener('focusout', () => this.setActive(null));
          item.querySelector('[data-variant-select]')?.addEventListener('change', (e) => this.onVariantChange(item, e.target));
          item.querySelector('[data-add]')?.addEventListener('click', (e) => this.addItem(item, e.currentTarget));
        });

        this.hotspots.forEach((spot) => {
          spot.addEventListener('pointerenter', () => this.setActive(spot.dataset.index));
          spot.addEventListener('pointerleave', () => this.setActive(null));
          spot.addEventListener('click', () => {
            const item = this.items.find((i) => i.dataset.index === spot.dataset.index);
            if (!item) return;
            this.setActive(spot.dataset.index);
            if (window.matchMedia('(max-width: 989px)').matches) {
              item.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
            item.classList.remove('is-flash');
            void item.offsetWidth;
            item.classList.add('is-flash');
          });
        });

        this.querySelector('[data-add-all]')?.addEventListener('click', (e) => this.addAll(e.currentTarget));
      }

      setActive(index) {
        this.items.forEach((i) => i.classList.toggle('is-active', i.dataset.index === index));
        this.hotspots.forEach((h) => h.classList.toggle('is-active', h.dataset.index === index));
      }

      formatMoney(cents) {
        const format = this.moneyFormat;
        const value = Number(cents) / 100;
        const withDelimiters = (number, decimals, thousands = ',', decimal = '.') => {
          const [whole, fraction] = number.toFixed(decimals).split('.');
          return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
        };
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!match) return value.toFixed(2);
        const map = {
          amount: () => withDelimiters(value, 2),
          amount_no_decimals: () => withDelimiters(value, 0),
          amount_with_comma_separator: () => withDelimiters(value, 2, '.', ','),
          amount_no_decimals_with_comma_separator: () => withDelimiters(value, 0, '.', ','),
          amount_with_apostrophe_separator: () => withDelimiters(value, 2, "'", '.'),
        };
        return format.replace(match[0], (map[match[1]] || map.amount)());
      }

      onVariantChange(item, select) {
        const option = select.selectedOptions[0];
        const button = item.querySelector('[data-add]');
        if (button) button.dataset.variantId = option.value;

        const price = item.querySelector('[data-price]');
        const compare = item.querySelector('[data-compare]');
        if (price) price.textContent = this.formatMoney(option.dataset.price);
        if (compare) {
          const onSale = Number(option.dataset.compare) > Number(option.dataset.price);
          compare.hidden = !onSale;
          if (onSale) compare.textContent = this.formatMoney(option.dataset.compare);
        }
        this.updateTotal();
      }

      updateTotal() {
        if (!this.totalEl) return;
        let total = 0;
        this.items.forEach((item) => {
          const button = item.querySelector('[data-add]');
          if (!button) return;
          const select = item.querySelector('[data-variant-select]');
          const cents = select ? select.selectedOptions[0].dataset.price : null;
          if (cents) total += Number(cents);
          else total += Number(item.querySelector('[data-price]')?.dataset.cents || 0);
        });
        if (total > 0) this.totalEl.textContent = this.formatMoney(total);
      }

      addItem(item, button) {
        this.addLines([{ id: Number(button.dataset.variantId), quantity: 1 }], button);
      }

      addAll(button) {
        const lines = this.items
          .map((item) => item.querySelector('[data-add]'))
          .filter(Boolean)
          .map((btn) => ({ id: Number(btn.dataset.variantId), quantity: 1 }));
        if (lines.length) this.addLines(lines, button);
      }

      setStatus(message, isError = false) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        this.statusEl.classList.toggle('is-error', isError);
        clearTimeout(this.statusTimer);
        this.statusTimer = setTimeout(() => (this.statusEl.textContent = ''), 4000);
      }

      async addLines(lines, trigger) {
        if (trigger.getAttribute('aria-busy') === 'true') return;
        trigger.setAttribute('aria-busy', 'true');

        const routes = window.Theme?.routes || {};
        const addUrl = routes.cart_add_url || '/cart/add.js';
        const cartUrl = routes.cart_url || '/cart';
        const sectionIds = [...document.querySelectorAll('cart-items-component')]
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        const quantity = lines.reduce((sum, line) => sum + line.quantity, 0);

        // Horizon's cart drawer, cart count and cart page listen for this event
        let events = null;
        try {
          events = await import('@shopify/events');
        } catch (error) {
          events = null;
        }
        const CartEvent = events?.CartLinesUpdateEvent;
        const deferred = CartEvent?.createPromise ? CartEvent.createPromise() : null;

        if (deferred) {
          this.dispatchEvent(
            new CartEvent({
              action: 'add',
              context: 'product',
              lines: lines.map((line) => ({ merchandiseId: String(line.id), quantity: line.quantity })),
              promise: deferred.promise,
            })
          );
        }

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: lines, sections: sectionIds.join(',') }),
          }).then((res) => res.json());

          const cart = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((res) =>
            res.json()
          );

          if (response.status) {
            deferred?.resolve({
              cart: CartEvent.createCartFromAjaxResponse(cart),
              detail: { didError: true, items: cart.items, source: 'product-form-component', sourceId: this.id, itemCount: 0 },
            });
            this.setStatus(response.description || response.message || 'Could not add to cart', true);
            return;
          }

          if (deferred) {
            deferred.resolve({
              cart: CartEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'product-form-component',
                sourceId: this.id,
                itemCount: quantity,
                sections: response.sections,
                didError: false,
              },
            });
          } else {
            window.location.href = cartUrl;
            return;
          }

          trigger.classList.add('is-added');
          setTimeout(() => trigger.classList.remove('is-added'), 2200);
          this.setStatus(quantity > 1 ? `${quantity} pieces added to cart` : 'Added to cart');
        } catch (error) {
          deferred?.reject(error);
          this.setStatus('Something went wrong. Please try again.', true);
        } finally {
          trigger.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('sp-shop-look', SpShopLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sp-trust-bar')) {
    customElements.define(
      'sp-trust-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('.sp-trust__item')];
          if (!this.classList.contains('sp-trust__list--rotate') || this.items.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.mobile = window.matchMedia('(max-width: 749px)');
          this.index = 0;
          this.items[0].classList.add('is-active');

          const step = () => {
            if (!this.mobile.matches || this.paused) return;
            this.items[this.index].classList.remove('is-active');
            this.index = (this.index + 1) % this.items.length;
            this.items[this.index].classList.add('is-active');
          };

          this.timer = setInterval(step, Number(this.dataset.interval) || 4000);
          this.addEventListener('pointerenter', () => (this.paused = true));
          this.addEventListener('pointerleave', () => (this.paused = false));
          this.addEventListener('focusin', () => (this.paused = true));
          this.addEventListener('focusout', () => (this.paused = false));
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
